module.exports = __webpack_public_path__ + "img/menu_icon.a4b2d028.svg";